export default __webpack_public_path__ + "static/media/Thumb-0.20103f9c.png";